import { useState, useEffect } from "react";
import { Card, Form, Modal, Button } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { useJobOpenings } from "../../app/hooks/useJobOpenings";
import { useJobOpeningsById } from "../../app/hooks/useJobOpenings";
import SaveChangesMessage from "./Modal/SaveChangesMessage";
import SuccessMessage from "./Modal/SuccessMessage";
import JobPostForm from "./form/JobPostForm";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const JobPostOpeningBody = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [employmentType, setEmploymentType] = useState();
  const { jobPostStore } = useStore();
  const jobOpeningApi = useJobOpenings();
  const {
    isSubmitting,
    loading,
    isSaveJobPostingModalVisible,
    setIsSaveJobPostingModalVisible,
    isDoneModalVisible,
    setIsDoneModalVisible,
    handleFinalSubmit,
    handleCloseJobPosting,
  } = jobPostStore;
  const { data: jobData, isLoading: isFetchingJob } = useJobOpeningsById(id);
  const isEditMode = !!id;
  const showSpinner = isEditMode && isFetchingJob;
  const [isCloseApplication, setIsCloseApplication] = useState(null);

  useEffect(() => {
    if (id && jobData) {
      form.setFieldsValue({
        ...jobData,
        departmentId: jobData.department.name,
        dateRange: jobData.startDate && jobData.endDate ? [dayjs(jobData.startDate), dayjs(jobData.endDate)] : null,
        startTime: jobData.startTime ? dayjs(jobData.startTime, "HH:mm:ss") : null,
        endTime: jobData.endTime ? dayjs(jobData.endTime, "HH:mm:ss") : null,
      });

      if (jobData.employmentType) {
        setEmploymentType(jobData.employmentType);
      }
    } else if (!id) {
      form.resetFields();
    }
  }, [jobData, id, form]);

  return (
    <div className="flex flex-col max-w-5xl mx-auto w-full">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl mb-4 font-bold text-gray-800">{id ? "Edit Job Opening" : "Post Job Opening"}</h2>
        {id ? (
          <Button
            type="primary"
            className="h-10 border-none font-bold text-xl rounded-xl shadow-md hover:opacity-90"
            style={{
              backgroundColor: "#FF0000",
              letterSpacing: "1px",
              width: "250px",
            }}
            onClick={() => setIsCloseApplication(true)}
          >
            CLOSE APPLICATION
          </Button>
        ) : null}
      </div>
      <Card className="shadow-lg rounded-2xl py-12 px-5">
        <JobPostForm form={form} employmentType={employmentType} setEmploymentType={setEmploymentType} isLoading={isSubmitting} isFetching={showSpinner} />
      </Card>

      <Modal width={400} open={isSaveJobPostingModalVisible} centered onCancel={() => setIsSaveJobPostingModalVisible(false)} footer={null} destroyOnClose>
        <SaveChangesMessage
          isLoading={isSubmitting}
          onCancel={() => setIsSaveJobPostingModalVisible(false)}
          onSaveSuccess={() => handleFinalSubmit(form.getFieldsValue(true), jobOpeningApi, id)}
        />
      </Modal>

      <Modal width={400} open={isDoneModalVisible} centered onCancel={() => setIsDoneModalVisible(false)} footer={null}>
        <SuccessMessage
          isEdit={isEditMode}
          onFinish={() => {
            setIsDoneModalVisible(false);
            navigate(`/recruitment/job-openings`);
          }}
        />
      </Modal>

      {/* for close application*/}
      <Modal width={400} open={isCloseApplication} centered onCancel={() => setIsCloseApplication(false)} footer={null} destroyOnClose>
        <SaveChangesMessage
          isLoading={loading}
          onCancel={() => setIsCloseApplication(false)}
          onSaveSuccess={() => {
            handleCloseJobPosting(id, jobOpeningApi).then(() => {
              navigate(`/recruitment/job-openings`);
            });
          }}
        />
      </Modal>
    </div>
  );
};
export default observer(JobPostOpeningBody);
